module.exports = __webpack_public_path__ + "img/146-62-floor.26211d00.jpg";